(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("leaflet-arc", [], factory);
	else if(typeof exports === 'object')
		exports["leaflet-arc"] = factory();
	else
		root["leaflet-arc"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/